import React from 'react';

import { Option } from '../../interfaces/option.interface';
import ConfirmationModal from '../ConfirmationModal';
import Sort from '../Sort';

export const INTEGRATOR_PLACEHOLDER_VALUE = 'PLEASE_SELECT_INTEGRATOR';

export const getIntegratorOptionsWithPlaceholder = (integratorOptions: Option[]): Option[] => [
  { label: 'Please select an integrator', value: INTEGRATOR_PLACEHOLDER_VALUE },
  ...integratorOptions,
];

export const getIntegratorName = (integratorOptions: Option[], integratorId: string): string => {
  const selectedOption = integratorOptions.find((option) => option.value === integratorId);

  return selectedOption ? selectedOption.label : '';
};

interface IntegratorSelectProps {
  integratorOptions: Option[];
  selected: string;
  onSelect: (value: string) => void;
}

export const IntegratorSelect: React.FC<IntegratorSelectProps> = ({ integratorOptions, selected, onSelect }) => (
  <Sort
    label="Integrator"
    onSelect={onSelect}
    options={getIntegratorOptionsWithPlaceholder(integratorOptions)}
    selected={selected}
    hideLabel
  />
);

interface IntegratorConfirmationModalProps {
  integratorId: string;
  integratorOptions: Option[];
  title: (integratorName: string) => string;
  text: (integratorName: string) => string;
  onDismiss: () => void;
  onSubmit: () => void;
}

export const IntegratorConfirmationModal: React.FC<IntegratorConfirmationModalProps> = ({
  integratorId,
  integratorOptions,
  title,
  text,
  onDismiss,
  onSubmit,
}) => {
  const integratorName = getIntegratorName(integratorOptions, integratorId);

  return (
    <ConfirmationModal title={title(integratorName)} text={text(integratorName)} onDismiss={onDismiss} onSubmit={onSubmit} />
  );
};
